import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react'
import { Link, NavLink, useParams } from 'react-router-dom';
import { Button, Card, Grid, Icon, Image } from 'semantic-ui-react'
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { Activity } from '../../../app/models/activity'
import { useStore } from '../../../app/stores/store';
import ActivityDetailedChat from './ActivityDetailedChat';
import ActivityDetailedHeader from './ActivityDetailedHeader';
import ActivityDetailedInfo from './ActivityDetailedInfo';
import ActivityDetailedSidebar from './ActivityDetailedSidebar';

// interface Props {
//     activity: Activity; //.selectedActivity
//     cancelSelectActivity: () => void; //.cancelSelectedActivity
//     openForm: (id: string) => void; //.formOpen
// }

//export default function ActivityDetails({activity, cancelSelectActivity, openForm} : Props) { //'
//export default function ActivityDetails({activity: selectedActivity, cancelSelectActivity: cancelSelectedActivity, openForm: formOpen} : Props) { //.
//export default function ActivityDetails() {
export default observer( function ActivityDetails() {
    const usStore = useStore(); //'n
    //const {id} = useParams(); //'n
    const usParams = useParams(); //.'n

    useEffect(() => {
        if (usParams.id) {
            usStore.activityStore.loadActivity(usParams.id)
        };

        return () => usStore.activityStore.clearSelectedActivity(); //'n  Error: Failed to start the connection: Error: The connection was stopped during negotiation.
    }, [usParams.id, usStore.activityStore.loadActivity, usStore.activityStore.clearSelectedActivity])

    //if(!usStore.activityStore.selectedActivity) return; //'n
    //if(!usStore.activityStore.selectedActivity) return <LoadingComponent />; //'n
    if(!usStore.activityStore.selectedActivity || usStore.activityStore.loadingInitial) return <LoadingComponent />; //' n

    return (
        // <Card fluid>
        //     <Image src={`/assets/categoryImages/${usStore.activityStore.selectedActivity.category}.jpg`} /> 
        //     <Card.Content>
        //     <Card.Header>{usStore.activityStore.selectedActivity.title}</Card.Header>
        //     <Card.Meta>
        //         <span>{usStore.activityStore.selectedActivity.date}</span>
        //     </Card.Meta>
        //     <Card.Description>
        //         {usStore.activityStore.selectedActivity.description}
        //     </Card.Description>
        //     </Card.Content>
        //     <Card.Content extra>
        //         <Button.Group width='2'>
        //             {/* <Button basic color='blue' content='Edit' onClick={() => usStore.activityStore.formOpen(usStore.activityStore.selectedActivity.id)}  /> */}
        //             {/* <Button basic color='blue' content='Edit' as={Link} to={`/updateActivity/${usStore.activityStore.selectedActivity.id}`} onClick={() => usStore.activityStore.loadActivity(usStore.activityStore.selectedActivity.id)} /> */}
        //             <Button basic color='blue' content='Edit' as={Link} to={`/manage/${usStore.activityStore.selectedActivity.id}`} />

        //             {/* <Button basic color='grey' content='Cancel' /> */}
        //             {/* <Button basic color='grey' content='Cancel' onClick={usStore.activityStore.cancelSelectedActivity} as={NavLink} to='/activities' /> */}
        //             <Button basic color='grey' content='Cancel' as={Link} to='/activities' />

        //         </Button.Group>
        //     </Card.Content>
        // </Card>

        <Grid>
            <Grid.Column width={10}>
                <ActivityDetailedHeader activity={usStore.activityStore.selectedActivity} />
                <ActivityDetailedChat activityId={usStore.activityStore.selectedActivity.id} />
                <ActivityDetailedInfo activity={usStore.activityStore.selectedActivity} />
            </Grid.Column>
            <Grid.Column width={6}>
                <ActivityDetailedSidebar activity={usStore.activityStore.selectedActivity!}  />
            </Grid.Column>
        </Grid>
    )

//} //'
})